
import { Vue, Component, Prop } from "vue-property-decorator";
import { SmartText, SmartSVG, SVGLibraryCustom, LinkLogic } from "_components";
import { createModifierClass } from "_utils";

import { HomePageWhatsComingBlockType } from "../../types";
@Component({
  name: "HomeWhatsComingCard",
  components: { SmartText, SmartSVG, LinkLogic },
})
export default class HomeWhatsComingCard extends Vue {
  @Prop() data!: HomePageWhatsComingBlockType;
  rootClass = "c-home-whats-coming-card";

  calIcon = SVGLibraryCustom.PQCalendar;

  get date() {
    return this.data.date;
  }

  get title() {
    return this.data.title;
  }

  get hasLink() {
    return this.data.enable_link;
  }

  get link() {
    return this.data.enable_link && this.data.link.link;
  }

  get wrapperClasses() {
    return [
      this.rootClass,
      ...createModifierClass(this.rootClass, this.hasLink, "has-link"),
    ];
  }
}
